import $ from "jquery";
import config from "../config";
const URL_API = config.urlApi + "controller/getAllPosts.php";

export default function getPosts(formData) {
  return $.ajax({
    url: URL_API,
    type: "POST",
    data: formData,
    contentType: false,
    processData: false,
  });
}
